import React, { useState, useEffect } from "react";
import { Modal, Radio, Select } from "antd";
import Api from "../../../../services/ServiceApi";
import Cookies from "js-cookie";
import { StatusInfo } from "../../../utility/status_info_modal";
export default function Canceljob({
  jobDetail,
  workflowJob,
  Modalshow,
  setModalshow,
}) {
  const [statusSubmit, setstatusSubmit] = useState(false);
  const { job_id, job_progress_id, job_type_id, project_id } = jobDetail;
  const [Spin, setSpin] = useState(true);
  const [valueRadio, setValueRadio] = useState(true);
  const [showText, setshowText] = useState("Loading..");
  const [statusInfoMode, setstatusInfoMode] = useState("success");

  const [selectJobType, setSelectJobType] = useState([]);
  const [selectJobSubType, setSelectJobSubType] = useState([]);
  const [selectAssignedGroup, setSelectAssignedGroup] = useState([]);

  const [valueJobType, setValueJobType] = useState(null);
  const [valueJobSubType, setValueJobSubType] = useState(null);
  const [valueAssignedGroup, setAssignedGroup] = useState(null);

  const [reqCheck, setReqCheck] = useState(null);


  function Canceljob() {
    setshowText("Sending Cancel Job");
    setstatusSubmit(true);
    let canCancelJob = false;
    if(valueAssignedGroup === null){
      setReqCheck(true)
    }
    else{
    if (workflowJob && workflowJob.length > 0) {
      workflowJob.map((data) => {
        if (data.next_main_action_id === 8 && data.next_main_process_id === 9) {
          canCancelJob = true;
          Api.post("/job_detail/go_next_process", {
            ...data,
            operator_id: Cookies.get("operator_id"),
            project_id: Cookies.get("project_id"),
            job_id: job_id,
            job_progress_id: job_progress_id,
            location_lat: 0,
            location_long: 0,
            create_by: Cookies.get("username"),
            job_type_id: job_type_id,
          })
            .then(async (res) => {
              if (res.data.result.code === "P") {

                const RejectJobItsm = await Api.post("JobItsm/RejectJobItsm", {
                  "so_id": jobDetail.so_id,
                  "Assignee": Cookies.get("userITSM"),
                  "project_id": jobDetail.project_id,
                  "IsCreateTask": valueRadio,
                  "job_id": jobDetail.job_id,
                  "AssignedGroup": valueAssignedGroup,
                  "job_type_id": valueJobType,
                  "job_sub_type_id": valueJobSubType

                });
                if (RejectJobItsm.data.result.code === "P") {
                  setshowText("Cancel Job Success");
                  setSpin(false);
                  setTimeout(() => {
                    window.location.reload();
                  }, 800);
                }
                else {
                  setshowText("Error : " + RejectJobItsm.data.result?.showText);
                  setSpin(false);
                  setstatusInfoMode("error");
                }

              } else {
                setshowText("Error : " + res.data.result?.showText);
                setSpin(false);
                setstatusInfoMode("error");
              }
            })
            .catch((e) => {
              setshowText("Error : " + e);
              setSpin(false);
              setstatusInfoMode("error");
            });
        }
      });
    }
    if (!canCancelJob) {
      setshowText("can't access this function");
      setstatusInfoMode("error");
      setSpin(false);
    }
          
  }
  }
  const statusInfoCallBack = () => {
    setstatusSubmit(false);
    setModalshow(false);
  };


  const onLoadMasterJobType = () => {
    Api.post("V4/get_job_type", {
      "pk_id": null,
      "fk_id": jobDetail.job_category_id,
      "is_active": "1",
      "effective": "1",
      "sql_where": null,
      "company_id": Cookies.get("companyid"),
      "operator_id": Cookies.get("operator_id"),
      "project_id": Cookies.get("project_id"),
      "UserName": Cookies.get("username")
    })
      .then((response) => {
        var setData = [];
        for (let i = 0; i < response.data.data.length; i++) {
          setData.push({
            value: response.data.data[i]["job_type_id"],
            label: response.data.data[i]["job_type_name"],
          });
        }
        setSelectJobType(setData);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  const onLoadMasterGetAssignedGroup = () => {
    Api.get("JobMaxi/GetAssignedGroup/" + project_id)
      .then((response) => {
        var setData = [];
        for (let i = 0; i < response.data.data.length; i++) {
          setData.push({
            value: response.data.data[i]["AssignedGroupName"],
            label: response.data.data[i]["AssignedGroupName"],
          });
        }
        setSelectAssignedGroup(setData);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  const onLoadMasterJobSub = () => {
    Api.post("get_job_sub_type", {
      "job_sub_type_id": null,
      "job_category_id": jobDetail.job_category_id,
      "job_type_id": jobDetail.job_type_id,
      "is_active": 1,
      "effective": 1,
      "sql_where": " and company_id=" + Cookies.get("companyid"),
      "operator_id": Cookies.get("operator_id")
    })
      .then((response) => {
        var setData = [];
        for (let i = 0; i < response.data.data.job_sub_type_dto_list.length; i++) {
          setData.push({
            value: response.data.data.job_sub_type_dto_list[i]["job_sub_type_id"],
            label: response.data.data.job_sub_type_dto_list[i]["job_type_name"],
          });
        }
        setSelectJobSubType(setData);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  const onLoadDataReject = () => {
    Api.get("JobMaxi/GetOperTierJobOper/" + job_id,)
      .then((response) => {
        setValueJobType(response.data.data.job_type_id);
        setValueJobSubType(response.data.data.job_sub_type_id);
        onLoadMasterJobType();
        onLoadMasterJobSub(response.data.data.job_type_id);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  useEffect(() => {
    onLoadDataReject();
    onLoadMasterGetAssignedGroup();
  }, []);

  return (
    <Modal
      title={null}
      centered
      visible={Modalshow}
      footer={null}
      closable={false}
    >
      {statusSubmit ? (
        <StatusInfo
          callbackFunction={statusInfoCallBack}
          showSpinIcon={Spin}
          statusText={showText}
          mode={statusInfoMode}
        ></StatusInfo>
      ) : (
        <div className="text-center">
          <div className="row d-flex justify-content-center">
            <img
              src={Api.absoluteUrl("/img/login_error.png")}
              className="img-fluid"
              alt="login_error"
            />
          </div>
          <div className="row d-flex justify-content-center">
            <span className="font-thai-b fs-22 c-blue">
              {`ยืนยันการยกเลิกงาน : ${jobDetail.job_no} / ${jobDetail.so_id}`}
            </span>
          </div>

          <div className="row">
            <div className="col-6">
              <span className="float-left mb-2">
                {"Job Type"}
              </span>
              <br />
              <Select
                size={"middle"}
                placeholder="Please select"
                value={valueJobType}
                onChange={(e) => setValueJobType(e)}
                style={{
                  width: '100%',
                }}
                options={selectJobType}
              />
            </div>
            <div className="col-6">
              <span className="float-left mb-2">
                {"Job Sub Type"}
              </span>
              <br />
              <Select
                size={"middle"}
                value={valueJobSubType}
                placeholder="Please select"
                onChange={(e) => setValueJobSubType(e)}
                style={{
                  width: '100%',
                }}
                options={selectJobSubType}
              />
            </div>
            <div className="col-12 mt-2 mb-2">
              <span className="float-left mb-2">
                {"Assigned Group Name"}
              </span>
              <br />
              <Select
                size={"middle"}
                value={valueAssignedGroup}
                style={reqCheck ?{border: "1px solid red" , width: '100%',} : {  border: "1px solid #d9d9d9"  ,  width: '100%',}}
                placeholder="Please select"
                onChange={(e) => { setAssignedGroup(e); setReqCheck(false);}}
                options={selectAssignedGroup}
              />
            </div>
            <br />
            {reqCheck ? 
                  <span className="float-left" style={{color: "red"}}>
                  {"กรุณาเลือก Assigned Group Name !!!"}
                </span>: null}
      
          </div>
          <div className="row d-flex justify-content-center m-2">
            <Radio.Group name="radiogroup" defaultValue={valueRadio} onChange={(e) => setValueRadio(e.target.value)}>
              <Radio value={true}>สร้าง Task  ITSM</Radio>
              <Radio value={false}>ไม่สร้าง Task  ITSM</Radio>
            </Radio.Group>
          </div>
          <div className="row d-flex justify-content-center mt-2">
            <button
              className="btn btn-secondary"
              onClick={() => setModalshow(false)}
            >
              Close
            </button>
            {statusSubmit ? (
              <button className="btn btn-success" disabled>
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </button>
            ) : (
              <button className="btn btn-success" onClick={() => Canceljob()}>
                Confirm
              </button>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
}
export function CanceljobonFulldetail({
  CompanyId,
  OperatorId,
  ProjectId,
  jobDetail,
  workflowJob,
  Modalshow,
  setModalshow,
  so_id,
}) {

  const [statusSubmit, setstatusSubmit] = useState(false);
  const [valueRadio, setValueRadio] = useState(true);
  const { job_id, job_progress_id, job_type_id } = jobDetail;
  const [Spin, setSpin] = useState(true);
  const [showText, setshowText] = useState("Loading..");
  const [statusInfoMode, setstatusInfoMode] = useState("success");

  const [selectJobType, setSelectJobType] = useState([]);
  const [selectJobSubType, setSelectJobSubType] = useState([]);
  const [selectAssignedGroup, setSelectAssignedGroup] = useState([]);

  const [valueJobType, setValueJobType] = useState(null);
  const [valueJobSubType, setValueJobSubType] = useState(null);
  const [valueAssignedGroup, setAssignedGroup] = useState(null);

  
  const [reqCheck, setReqCheck] = useState(null);

  function Canceljob() {
    setshowText("Sending Cancel Job");
    setstatusSubmit(true);
    let canCancelJob = false;
    if (workflowJob && workflowJob.length > 0) {
      workflowJob.map((data) => {
        if (data.next_main_action_id === 8 && data.next_main_process_id === 9) {
          canCancelJob = true;
          Api.post("/job_detail/go_next_process", {
            ...data,
            operator_id: OperatorId,
            project_id: ProjectId,
            job_id: job_id,
            job_progress_id: job_progress_id,
            location_lat: 0,
            location_long: 0,
            create_by: Cookies.get("username"),
            job_type_id: job_type_id,
          })
            .then(async (res) => {
              if (res.data.result.code === "P") {
                  setshowText("Cancel Job Success");
                  setSpin(false);
                  setTimeout(() => {
                    window.location.reload();
                  }, 800);
              } else {
                setshowText("Error : " + res.data.result?.showText);
                setSpin(false);
                setstatusInfoMode("error");
              }
            })
            .catch((e) => {
              setshowText("Error : " + e);
              setSpin(false);
              setstatusInfoMode("error");
            });
        }
      });
    }
    if (!canCancelJob) {
      setshowText("can't access this function");
      setstatusInfoMode("error");
      setSpin(false);
    }
  }
  const statusInfoCallBack = () => {
    setstatusSubmit(false);
    setModalshow(false);
  };

  const onLoadMasterJobType = () => {
    Api.post("V4/get_job_type", {
      "pk_id": null,
      "fk_id": jobDetail.job_category_id,
      "is_active": "1",
      "effective": "1",
      "sql_where": null,
      "company_id": CompanyId,
      "operator_id": OperatorId,
      "project_id": ProjectId,
      "UserName": Cookies.get("username")
    })
      .then((response) => {
        var setData = [];
        for (let i = 0; i < response.data.data.length; i++) {
          setData.push({
            value: response.data.data[i]["job_type_id"],
            label: response.data.data[i]["job_type_name"],
          });
        }
        setSelectJobType(setData);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  const onLoadMasterGetAssignedGroup = () => {
    Api.get("JobMaxi/GetAssignedGroup/" + ProjectId)
      .then((response) => {
        var setData = [];
        for (let i = 0; i < response.data.data.length; i++) {
          setData.push({
            value: response.data.data[i]["AssignedGroupName"],
            label: response.data.data[i]["AssignedGroupName"],
          });
        }
        setSelectAssignedGroup(setData);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  const onLoadMasterJobSub = () => {
    Api.post("get_job_sub_type", {
      "job_sub_type_id": null,
      "job_category_id": jobDetail.job_category_id,
      "job_type_id": jobDetail.job_type_id,
      "is_active": 1,
      "effective": 1,
      "sql_where": " and company_id=" + CompanyId,
      "operator_id": OperatorId
    })
      .then((response) => {
        var setData = [];
        for (let i = 0; i < response.data.data.job_sub_type_dto_list.length; i++) {
          setData.push({
            value: response.data.data.job_sub_type_dto_list[i]["job_sub_type_id"],
            label: response.data.data.job_sub_type_dto_list[i]["job_type_name"],
          });
        }
        setSelectJobSubType(setData);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  const onLoadDataReject = () => {
    Api.get("JobMaxi/GetOperTierJobOper/" + job_id,)
      .then((response) => {
        setValueJobType(response.data.data.job_type_id);
        setValueJobSubType(response.data.data.job_sub_type_id);
        onLoadMasterJobType();
        onLoadMasterJobSub(response.data.data.job_type_id);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  useEffect(() => {
    onLoadDataReject();
    onLoadMasterGetAssignedGroup();
  }, []);

  return (
    <Modal
      title={null}
      centered
      visible={Modalshow}
      footer={null}
      closable={false}
    >
      {statusSubmit ? (
        <StatusInfo
          callbackFunction={statusInfoCallBack}
          showSpinIcon={Spin}
          statusText={showText}
          mode={statusInfoMode}
        ></StatusInfo>
      ) : (
        <div className="text-center">
          <div className="row d-flex justify-content-center">
            <img
              src={Api.absoluteUrl("/img/login_error.png")}
              className="img-fluid"
              alt="login_error"
            />
          </div>
          <div className="row d-flex justify-content-center">
            <span className="font-thai-b fs-22 c-blue">
              {`ยืนยันการยกเลิกงาน : ${jobDetail.job_no} / ${jobDetail.so_id ? jobDetail.so_id : so_id ? so_id : `-`
                }`}
            </span>
          </div>
          {/* <div className="row">
            <div className="col-6">
              <span className="float-left mb-2">
                {"Job Type"}
              </span>
              <br />
              <Select
                size={"middle"}
                placeholder="Please select"
                value={valueJobType}
                onChange={(e) => setValueJobType(e)}
                style={{
                  width: '100%',
                }}
                options={selectJobType}
              />
            </div>
            <div className="col-6">
              <span className="float-left mb-2">
                {"Job Sub Type"}
              </span>
              <br />
              <Select
                size={"middle"}
                value={valueJobSubType}
                placeholder="Please select"
                onChange={(e) => setValueJobSubType(e)}
                style={{
                  width: '100%',
                }}
                options={selectJobSubType}
              />
            </div>
            <div className="col-12 mt-2 mb-2">
              <span className="float-left mb-2">
                {"Assigned Group Name"}
              </span>
              <br />
              <Select
                size={"middle"}
                value={valueAssignedGroup}
                placeholder="Please select"
                onChange={(e) => { setAssignedGroup(e); setReqCheck(false);}}
                style={reqCheck ?{border: "1px solid red" , width: '100%',} : {   border: "1px solid #d9d9d9" ,  width: '100%',}}
                options={selectAssignedGroup}
              />
                <br />
                           {reqCheck ? 
                  <span className="float-left" style={{color: "red"}}>
                  {"กรุณาเลือก Assigned Group Name !!!"}
                </span>: null}
            </div>
          </div>
          <div className="row d-flex justify-content-center m-2">
            <Radio.Group name="radiogroup" defaultValue={valueRadio} onChange={(e) => setValueRadio(e.target.value)}>
              <Radio value={true}>สร้าง Task  ITSM</Radio>
              <Radio value={false}>ไม่สร้าง Task  ITSM</Radio>
            </Radio.Group>
          </div> */}
          <div className="row d-flex justify-content-center mt-2">
            <button
              className="btn btn-secondary"
              onClick={() => setModalshow(false)}
            >
              Close
            </button>
            {statusSubmit ? (
              <button className="btn btn-success" disabled>
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </button>
            ) : (
              <button className="btn btn-success" onClick={() => Canceljob()}>
                Confirm
              </button>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
}
